export const COPY_TYPES = Object.freeze({
  COPY_ONLY: 'copy_only',
  CHECKBOX: 'copy_with_checkbox',
})

export function getCopyData(terms: any, copyType: any) {
  if (!terms) return { body: '', check_by_default: false }
  const term = terms.find((term: any) => term.type === copyType)
  return term ? term : { body: '', check_by_default: false }
}

export function getCheckboxData(terms: any, index: number) {
  if (!terms) return { body: '', checkedByDefault: false, required: false }
  const checkboxTerms = terms.filter((term: any) => term.type === COPY_TYPES.CHECKBOX)
  const term = checkboxTerms[index]
  return term ? term : { body: '', checkedByDefault: false, required: false }
}

export function stripPrefix(content: string) {
  return content.replace(/^<p>(\(Optional\) |\(Required\) )/, '<p>')
}

export function getHtmlContentTextLength(html: string): number {
  const el = document.createElement('div')
  el.innerHTML = html.trim()
  return el.textContent?.length || 0
}

// A client without a saved list of unsupported state codes blocks Texas by default. An empty list blocks no state.
export function isBlockingTexasAreaCodes(unsupportedStateCodes?: string[] | null): boolean {
  return (unsupportedStateCodes || ['TX']).includes('TX')
}
